import type { EndpointDefinition } from "../_sdk/types/common";

import { endpoints as metadataEndpoints } from "./metadata/endpoints";
import { endpoints as workspaceEndpoints } from "./workspaces/endpoints";
import { endpoints as subscriptionsEndpoints } from "./workspaceBilling/endpoints";
import { endpoints as enterpriseEndpoints } from "./enterprise/endpoints";
import { endpoints as collaborationInvitesEndpoints } from "./collaborationInvites/endpoints";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    ...metadataEndpoints,
    ...workspaceEndpoints,
    ...subscriptionsEndpoints,
    ...enterpriseEndpoints,
    ...collaborationInvitesEndpoints
};
